import { render } from "./About1.vue?vue&type=template&id=245ad7ae&scoped=true"
import script from "./About1.vue?vue&type=script&lang=js"
export * from "./About1.vue?vue&type=script&lang=js"

import "./About1.vue?vue&type=style&index=0&id=245ad7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245ad7ae"]])

export default __exports__